import authApi from '@/api/modules/auth.js'

const state = {
  token: localStorage.getItem('admin-token') || '',
  adminInfo: JSON.parse(localStorage.getItem('admin-info') || '{}'),
  permissions: JSON.parse(localStorage.getItem('admin-permissions') || '[]'),
  roles: JSON.parse(localStorage.getItem('admin-roles') || '[]')
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('admin-token', token)
  },
  SET_ADMIN_INFO: (state, adminInfo) => {
    state.adminInfo = adminInfo
    localStorage.setItem('admin-info', JSON.stringify(adminInfo))
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
    localStorage.setItem('admin-permissions', JSON.stringify(permissions))
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
    localStorage.setItem('admin-roles', JSON.stringify(roles))
  },
  CLEAR_AUTH: (state) => {
    state.token = ''
    state.adminInfo = {}
    state.permissions = []
    state.roles = []
    localStorage.removeItem('admin-token')
    localStorage.removeItem('admin-info')
    localStorage.removeItem('admin-permissions')
    localStorage.removeItem('admin-roles')
  }
}

const actions = {
  // 登录 - 使用真实API
  login({ commit }, loginData) {
    return new Promise((resolve, reject) => {
      authApi.login(loginData)
        .then(response => {
          const payload = response?.data && typeof response.data === 'object' ? response.data : response
          const token = payload?.token || payload?.data?.token || response?.token || response?.data?.token
          const user = payload?.user || payload?.data?.user || response?.user || response?.data?.user
          const message = payload?.message || response?.message || '登录失败'
          const code = payload?.code ?? response?.code

          if (token && user) {
            commit('SET_TOKEN', token)
            commit('SET_ADMIN_INFO', user)

            const permissions = user.permissions || ['*']
            const roles = user.roles || [user.role || 'admin']

            commit('SET_PERMISSIONS', permissions)
            commit('SET_ROLES', roles)

            resolve({
              code: 200,
              message: payload?.message || '登录成功',
              data: {
                token,
                adminInfo: user
              }
            })
            return
          }

          if (typeof code !== 'undefined' || payload?.message || response?.message) {
            const businessError = new Error(message)
            businessError.code = code
            businessError.response = response
            reject(businessError)
            return
          }

          console.error('登录响应格式错误:', response)
          reject(new Error('登录响应格式错误'))
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取管理员信息 - 使用真实API
  getAdminInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.token) {
        authApi.getAdminInfo()
          .then(response => {
            const user = response.user || response.data || response
            commit('SET_ADMIN_INFO', user)
            resolve({
              code: 200,
              message: '成功',
              data: user
            })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        reject(new Error('未登录'))
      }
    })
  },

  // 登出 - 使用真实API
  logout({ commit }) {
    return new Promise((resolve) => {
      authApi.logout()
        .then(() => {
          commit('CLEAR_AUTH')
          resolve()
        })
        .catch(() => {
          commit('CLEAR_AUTH')
          resolve()
        })
    })
  },

  // 获取权限列表 - 使用真实API
  getPermissions({ commit, state }) {
    return new Promise((resolve, reject) => {
      authApi.getPermissions()
        .then(response => {
          const permissions = response.permissions || response.data || []
          if (permissions.length === 0 && (state.permissions.includes('*') || state.roles.includes('admin'))) {
            resolve({
              code: 200,
              message: '成功',
              data: state.permissions
            })
            return
          }
          commit('SET_PERMISSIONS', permissions)
          resolve({
            code: 200,
            message: '成功',
            data: permissions
          })
        })
        .catch(error => {
          console.warn('获取权限失败，保持当前权限不变:', error.message)
          resolve({
            code: 200,
            message: '获取权限失败，使用当前权限',
            data: state.permissions
          })
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: {
    token: state => state.token,
    adminInfo: state => state.adminInfo,
    permissions: state => state.permissions,
    roles: state => state.roles,
    isAuthenticated: state => !!state.token
  }
}
